module.exports = __webpack_public_path__ + "static/img/ydh2_quit_cancel.ffb07954.png";